/**
 * External dependencies
 */
import React from 'react';
import classnames from 'classnames';
import { Box } from '@towersystems/towersystems-design-system';
import Icon from 'components/icon';

import Name from 'components/name';

import './styles.scss';

const FormInputCheckbox = ({ className, checked, label, children, ...otherProps }) => (
    <Box>
        <label className={classnames(className, 'form-checkbox', { 'is-checked': checked })}>
            <Box class='form-checkbox__input'>
                <input {...otherProps} checked={checked} type='checkbox' className={'form-checkbox__input'} />
                {checked && <Icon type='bi' name='BiCheck' />}
            </Box>
            <span><Name value={label} /></span>
        </label>
        {children && <Box className='form-checkbox__additional-content'>{children}</Box>}
    </Box>
);

export default FormInputCheckbox;
